module.exports = __webpack_public_path__ + "static/media/b21.8a48ed8b.svg";